import Vue from 'vue'
import 'vant/lib/index.css'
// 在这里引入你所需的组件
import {
    Toast,
    NavBar,
    Form,
    Field,
    Button,
    Picker,
    Popup,
    Image as VanImage,
    Overlay,
    CountDown,
    Loading,
    Progress,
    Checkbox,
    CheckboxGroup,
    Radio,
    RadioGroup,
    Uploader,
} from 'vant'

// 按需引入UI组件
Vue.use(Toast);
Vue.use(NavBar);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(VanImage);
Vue.use(Overlay);
Vue.use(CountDown);
Vue.use(Loading);
Vue.use(Progress);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Uploader);



// WEBPACK FOOTER //
// ./src/assets/js/vant.js